import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { isObservable, of, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileMediaService } from 'src/app/services/file-media/file-media.service';

@Pipe({
  name: 'SafeImageLoader'
})
export class SafeImageLoaderPipe implements PipeTransform, OnDestroy {

  private destroy$: Subject<void> = new Subject();

  constructor(private fileMediaService: FileMediaService) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  transform(value: any, args?: any): Observable<SafeResourceUrl> {
    if (!value) {
      return of(null);
    }

    let item: any = Array.isArray(value) ? value[0] : value;

    if (this.isObjectId(item)) {
      const imageUrlObs: Observable<SafeResourceUrl> = this.fileMediaService.getUrlObs(item);
      return imageUrlObs.pipe(takeUntil(this.destroy$));
    }

    // populated file media
    if (item.url) {
      return of(item.url);
    }

    // simple string url
    if (item.toString()?.includes('http')) {
      return of(item);
    }

    // never append, just to be sure
    return of(item);
  }

  private isObjectId(value: string): boolean {
    const regex = new RegExp('^[a-fA-F0-9]{24}$');
    return regex.test(value);
  }
}
